import actionTypes from './actionTypes';

export const assign = (filters) => ({
  type: actionTypes.ASSIGN,
  payload: {
    filters,
  },
});
